import { ChangeEvent, useState } from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Card from "@mui/material/Card";

import formCadastroEvento from "../schemas/forms";
import { deleteDocumentoEvento } from "services/evento";
import { getFileNameFromUrl } from "helpers/utils";

// Material ui Icon
import {
  DeleteOutlineTwoTone,
  PictureAsPdfOutlined,
} from "@mui/icons-material";

import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MDEditor from "components/MDEditor";
import MDButton from "components/MDButton";

import { setMessage, useMaterialUIController } from "context";

const { formField } = formCadastroEvento;
const { resumo } = formField;

interface FieldDetailsProps {
  eventoId?: number;
  values: {
    [x: string]: string;
  };
  fileResumo: File | null;
  handlerDeleteFileResumo: () => void;
  handlerFileResumo: (event: ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export default function FieldInfoComplementar({
  values,
  eventoId,
  fileResumo,
  handlerDeleteFileResumo,
  handlerFileResumo,
  setFieldValue,
}: FieldDetailsProps) {
  const [, dispatch] = useMaterialUIController();
  const DeleteFileResumo = (): JSX.Element => {
    const [confirmed, setConfirmed] = useState<boolean>(false);

    return !confirmed ? (
      <IconButton component="label" onClick={() => setConfirmed(true)}>
        <DeleteOutlineTwoTone color="error" />
      </IconButton>
    ) : (
      <MDBox>
        <Typography variant="caption">Tem certeza?</Typography>
        <MDBox display="flex" gap={1}>
          <MDButton
            variant="outlined"
            color="success"
            size="small"
            onClick={handlerExcluirArquivo}
          >
            Sim
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            size="small"
            onClick={() => setConfirmed(false)}
          >
            Não
          </MDButton>
        </MDBox>
      </MDBox>
    );
  };

  const handlerExcluirArquivo = async () => {
    try {
      eventoId &&
        (await deleteDocumentoEvento(
          Number(eventoId),
          "urlResumo",
          getFileNameFromUrl(values.urlResumo)
        ).then((resp) => {
          if (resp.status === 200) {
            handlerDeleteFileResumo();
            setFieldValue("urlResumo", "");
          }
        }));
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        text: error.message,
        severity: "error",
      });
    }
  };

  return (
    <Card id="info-complementar" sx={{ overflow: "visible", margin: "10px 0" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">
            Informações complementar sobre o evento
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox pb={3} px={3}>
        <MDBox
          borderRadius="lg"
          display="flex"
          justifyContent={fileResumo ? "space-between" : "flex-start"}
          alignItems="center"
          p={1}
          sx={{
            backgroundColor: ({ palette: { light } }) => light.main,
            position: "relative",
            height: "auto",
            minHeight: "40px",
            border: ({ borders: { borderWidth, borderColor } }) =>
              `${borderWidth[1]} dashed ${borderColor}`,
          }}
        >
          {fileResumo ? (
            <>
              <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfOutlined fontSize="small" />
                <Typography variant="caption">{fileResumo.name}</Typography>
              </MDBox>
              <Typography variant="caption">{fileResumo.size} byte</Typography>
              <IconButton component="label" onClick={handlerDeleteFileResumo}>
                <DeleteOutlineTwoTone color="error" />
              </IconButton>
            </>
          ) : values.urlResumo !== "" ? (
            <MDBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <MDTypography
                component="a"
                href={values.urlResumo}
                target="_blank"
                rel="noreferrer"
                variant="h6"
                textTransform="capitalize"
                sx={{
                  display: "flex",
                  justifyItems: "space-between",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <PictureAsPdfOutlined fontSize="small" />
                {getFileNameFromUrl(values.urlResumo)}
              </MDTypography>

              <DeleteFileResumo />
            </MDBox>
          ) : (
            <IconButton component="label" sx={{ padding: "10px", gap: 1 }}>
              <input
                name="urlResumo"
                hidden
                accept="application/pdf"
                type="file"
                onChange={handlerFileResumo}
              />
              <PictureAsPdfOutlined fontSize="large" />
              <Typography variant="caption">Selecionar arquivo</Typography>
            </IconButton>
          )}
        </MDBox>
      </MDBox>

      {!fileResumo && (
        <MDBox pb={3} px={3}>
          <MDEditor
            name={resumo.name}
            value={values.resumo}
            onChange={setFieldValue}
            placeholder="Informações complementar sobre o evento..."
          />
        </MDBox>
      )}
    </Card>
  );
}
